import * as React from 'react';
import { Box, Button, TextField, Typography } from '@material-ui/core';
import { toast } from 'react-toastify';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { createLeadsAsync } from './ManagementStore/managementStoreSlice';

const GetInTouchForm = ({ id, handleClose }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const dispatch = useDispatch();

  const handleCreateLead = async () => {
    let reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    if (reg.test(email) === true) {
      try {
        let payload = {
          name: name,
          email: email,
          phone: phone,
          schoolId: id,
        };
        dispatch(createLeadsAsync(payload))
          .unwrap()
          .then((res) => {
            toast.success(`Lead has been created successully!`);
          });
        handleClose();
      } catch (error) {
        toast.error('Lead could not be created!');
      }
    } else {
      toast.error('Please Verify Email!');
    }
  };

  return (
    <Box>
      <Typography>
        <h2 style={{ margin: 0 }}>Get In Touch</h2>
      </Typography>
      <Box mt={2} />
      <TextField
        placeholder="Name"
        variant="outlined"
        size="small"
        value={name}
        fullWidth
        onChange={(e) => setName(e.target.value)}
      />
      <Box mt={2} />
      <TextField
        type="email"
        placeholder="Email"
        variant="outlined"
        size="small"
        value={email}
        fullWidth
        onChange={(e) => setEmail(e.target.value)}
      />
      <Box mt={2} />
      <TextField
        type="number"
        placeholder="Phone"
        variant="outlined"
        size="small"
        value={phone}
        fullWidth
        onChange={(e) => setPhone(e.target.value)}
      />
      <Box mt={2} />
      <Button
        disabled={
          name === '' ||
          email === '' ||
          phone === '' ||
          phone.length < 10 ||
          phone.length > 10
            ? true
            : false
        }
        onClick={handleCreateLead}
        color="primary"
        variant="contained">
        Submit
      </Button>
    </Box>
  );
};

export default GetInTouchForm;
